// Zipy deprecation shim: no-op exports + window.zipy stub. Delete this file (and the side-effect import in App.tsx) to fully remove Zipy.
import { useCallback } from 'react';

import { getExtendedLogger } from '@mindtickle/ui-shell-core/Logger';

import logger from '~/config/app.logger';
import type { TLocalAuthContext } from '~/components/Auth';

export type TZipy = {
  init: (projectId: string, extra?: { [key: string]: string }) => boolean;
  identify: (userId: string, extra: { [key: string]: string }) => void;
  getCurrentSessionURL(): string;
  logException: (error: Error) => void;
  logError: <T>(errorType: string, errorMessage: string, category: string, errInfo: T) => void;
};

declare global {
  interface Window {
    zipy: TZipy;
  }
}

const log = getExtendedLogger('zipy', logger);

const REAL_METHODS = new Set<string>([
  'init',
  'identify',
  'getCurrentSessionURL',
  'logException',
  'logError',
]);

function installWindowZipyStub() {
  if (typeof window === 'undefined' || window.zipy) {
    return;
  }
  const stubHandler: ProxyHandler<Record<string, unknown>> = {
    get(_target, prop) {
      if (typeof prop !== 'string' || !REAL_METHODS.has(prop)) {
        return undefined;
      }
      return () => {
        log(`Zipy is deprecated: window.zipy.${prop} called`);
        if (prop === 'getCurrentSessionURL') return '';
        if (prop === 'init') return true;
        return undefined;
      };
    },
  };
  window.zipy = new Proxy({}, stubHandler) as TZipy;
}

installWindowZipyStub();

export async function load() {
  log('Zipy is deprecated: load() called');
}

export async function init(_userId: string, _extra: { [key: string]: string }) {
  log('Zipy is deprecated: init() called');
}

export function useZipy(_auth?: TLocalAuthContext) {
  const initCb = useCallback(async () => {
    log('Zipy is deprecated: useZipy().init() called');
  }, []);

  return { init: initCb };
}
